import { IsBoolean, IsUUID } from 'class-validator';

export class SaveSectionResult {
  @IsUUID()
  sectionId: string;

  @IsBoolean()
  success: boolean;
}
